import Panzoom from "@panzoom/panzoom";

export function panzoom() {
  // Panzoom instance — kept in closure so destroy() can tear it down.
  let pz = null;

  return {
    init() {
      const stageEl = this.$refs.stage || null;

      if(!stageEl) {
        console.log('stage not found');
        return;
      }

      const maxScale = 3;

      pz = Panzoom(stageEl, {
        maxScale: maxScale,
        contain: 'outside'
      });

      const zoomInBtn = this.$refs.zoomIn || null;
      const zoomOutBtn = this.$refs.zoomOut || null;

      function disableButtons() {
        var scale = pz.getScale();

        if ( scale >= maxScale ) {
          zoomInBtn.disabled = true;
        } else {
          zoomInBtn.disabled = false;
        }

        if ( scale <= 1.01 ) {
          zoomOutBtn.disabled = true;
        } else {
          zoomOutBtn.disabled = false;
        }
      }

      // Panning and pinch zooming are bound automatically (unless disablePan is true).
      // Custom Controls
      function adjustScale(zoomIn) {
        if (zoomIn) {
          pz.zoomIn();
        } else {
          pz.zoomOut();
        }
      }

      if (!zoomInBtn || !zoomOutBtn) {
        console.log('zoom buttons not found');
      } else {
        zoomInBtn.addEventListener('click', () => adjustScale(true))
        zoomOutBtn.addEventListener('click', () => adjustScale(false));
      }

      stageEl.addEventListener('panzoomchange', () => disableButtons());

      // Mouse wheel
      stageEl.parentElement.addEventListener('wheel', pz.zoomWithWheel);

      // Ready
      disableButtons();
    },

    // Alpine calls destroy() when the element leaves the DOM (Unpoly fragment
    // swap). Panzoom binds pointer handlers (and document-level listeners while
    // dragging); destroy() releases them so nothing leaks across navigations.
    destroy() {
      pz?.destroy();
      pz = null;
    }
  };
}
